import { render, staticRenderFns } from "./GrowsafeManager.vue?vue&type=template&id=5a65ee36&"
import script from "./GrowsafeManager.vue?vue&type=script&lang=js&"
export * from "./GrowsafeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GrowsafeManager.vue"
export default component.exports